"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _colors = require("../../style/colors");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "className", "colorScheme", "max", "theme", "title", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  var keys = Object.keys(_colors.COLORS);
  var PROGRESS_BACKGROUND_COLOR = theme.colors.lightGrey;
  var PROGRESS_VALUE_COLOR = theme.colors.black;
  var PROGRESS_STYLES = function PROGRESS_STYLES(value, background) {
    return {
      backgroundColor: background,
      color: value,
      '&::-webkit-progress-bar': {
        backgroundColor: background
      },
      '&::-webkit-progress-value': {
        backgroundColor: value
      },
      '&::-moz-progress-bar': {
        backgroundColor: value
      }
    };
  };
  return {
    root: _objectSpread(_objectSpread({}, PROGRESS_STYLES(PROGRESS_VALUE_COLOR, PROGRESS_BACKGROUND_COLOR)), {}, {
      appearance: 'none',
      // Reset the default appearance
      overflow: 'hidden',
      display: 'block',
      width: '100%',
      height: '.75rem',
      border: 'none',
      // Get rid of default border in Firefox
      borderRadius: '0.125em',
      '&::-ms-fill': {
        border: 'none'
      }
    }),
    colorScheme: keys.reduce(function (accumulator, color) {
      var hex = _colors.COLORS[color];
      return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, "&[data-color=\"".concat(color, "\"]"), {
        color: hex,
        '&::-webkit-progress-value': {
          backgroundColor: hex
        },
        '&::-moz-progress-bar': {
          backgroundColor: hex
        }
      }));
    }, {}),
    complete: _objectSpread({}, PROGRESS_STYLES(theme.colors.olive, theme.colors.olive))
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLProgressElement & {
    colorScheme?: string
  };*/
var Progress = function Progress(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    colorScheme = _ref /*:: */.colorScheme,
    max = _ref /*:: */.max,
    theme = _ref /*:: */.theme,
    title = _ref /*:: */.title,
    value = _ref /*:: */.value,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("progress", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, value === 100 ? classes.complete : classes.colorScheme, true), className),
    "data-color": colorScheme || undefined,
    title: title || "".concat(value, "%"),
    max: max // Must declare `max` before `value` prop in IE11
    ,
    value: value
  }, props), title);
};
Progress.displayName = 'Progress';
Progress.defaultProps = {
  max: 100,
  value: 0
};
var _default = exports.default = (0, _injectSheet.default)(Style)(Progress);
//# sourceMappingURL=Progress.js.map